import { useState } from "react";
import ContactForm from "./ContactForm";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    terms: false,
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form fields
    const { name, email, subject, message, terms } = formData;
    if (!name || !email || !subject || !message || !terms) {
      alert("Please fill in all fields and agree to the terms.");
      return;
    }

    // If all fields are filled, proceed with form submission
    console.log(formData);
  };

  return (
    <div id="contact" className="form-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="text-container">
              <h2>Contact Details</h2>
              <p>
                For registration questions please get in touch using the contact
                details below. For any questions use the form.
              </p>
              <h3>Main Office Location</h3>
              <ul className="list-unstyled li-space-lg">
                <li className="media">
                  <i className="fas fa-map-marker-alt"></i>
                  <div className="media-body">
                    22 Innovative, San Francisco, CA 94043, US
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-mobile-alt"></i>
                  <div className="media-body">
                    +44 68 554 332, &nbsp;&nbsp;
                    <i className="fas fa-mobile-alt"></i>&nbsp; +44 31 276 112
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-envelope"></i>
                  <div className="media-body">
                    <a className="light-gray" href="mailto:contact@zigo.com">
                      contact@zigo.com
                    </a>{" "}
                    <i className="fas fa-globe"></i>
                    <a className="light-gray" href="#your-link">
                      www.zigo.com
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <ContactForm
              formData={formData}
              handleSubmit={handleSubmit}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
